/**
 * @module Icon
 * @description
 */
import React, { FC } from 'react';
import styles from './index.module.css';

interface Props {
  icon?: string;
  className?: string;
}

const Icon: FC<Props> = ( { ...props } ) => {
  const {
    icon = 'checkmark1',
    className = ''
  } = props;

  return (
    <span className={ `${ styles.icon } icon-${ icon } ${ className }` } />
  );
};

Icon.displayName = 'Icon';

export default Icon;
